import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";

import templateContent from "./live-search.html";

class LiveSearchComponent extends Component {
	constructor () {
		super("liveSearchComponent");

		this.addTemplate("", templateContent);

		this.behavior = "live";
		this.delayTimerId = null;
	}

	afterRender () {
		if (this.behavior === "live") {
			this.filter();
		}
		else {
			const liveSearchFilter = Shark.get("liveSearchFilter");

			liveSearchFilter.set({
				visibleCount: document.querySelectorAll(".searchableItem").length,
			});	
		}

		if (Shark.activePage.textFilters) {
			const liveSearchFilter = Shark.get("liveSearchFilter");
			const replaceRE = new RegExp(`(${liveSearchFilter.searchKey})`, "gi");

			for (let currProp in Shark.activePage.textFilters) {
				// console.log({currProp})
				document.querySelectorAll(`[data-search-field*="${currProp}"]`).forEach(item => {
					item.innerHTML = item.innerHTML.replace(replaceRE, `<span class="text-search-hilite">$&</span>`);
				});
				document.querySelectorAll(`[data-search-hilite-item="${currProp}"]`).forEach(item => {
					if (item.dataset.hasOwnProperty("searchValue") && replaceRE.test(item.dataset.searchValue)) {
						item.classList.add("text-search-hilite");
					}
				});
			}
		}
	}

	beforeLoad () {
		this.reset();

		if ((Shark.activePage.textFilters?.searchKey || "") !== "") {
			const liveSearchFilter = Shark.get("liveSearchFilter");
			liveSearchFilter.searchKey = Shark.activePage.textFilters.searchKey;
			// liveSearchFilter.set("searchKey", Shark.activePage.textFilters.searchKey);
		}
	}

	beforeUnload () {
		this.set({searchHint: ""});
	}

	doFilter () {
		const liveSearchFilter = Shark.get("liveSearchFilter");
		const key = liveSearchFilter.searchKey;
		let visibleCount = 0;

		if (key !== "") {
			$(".searchableItem").each((index, item) => {
				const $item = $(item);

				if ($item.data("searchInfo").toLowerCase().indexOf(key) > -1) {
					$item.closest(".searchableItem").show();
					visibleCount++;
				}
				else {
					$item.closest(".searchableItem").hide();
				}
			});
		}
		else {
			$(".searchableItem").show();
		}

		liveSearchFilter.set({
			visibleCount
		});

		const liveFilterCountDisplay = document.querySelector("#liveFilterCountDisplay");
		if (liveFilterCountDisplay) {
			if (visibleCount > 0) {
				liveFilterCountDisplay.classList.remove("d-none");
			}
			else {
				liveFilterCountDisplay.classList.add("d-none");
			}
		}

		if (typeof Shark.activePage.updateTotals === "function") {
			Shark.activePage.updateTotals();
		}
	}

	filter (searchKey) {
		if (this.behavior === "live") {
			this.doFilter();
		}
		else {
			if (this.delayTimerId) {
				clearTimeout(this.delayTimerId);
			}
			this.delayTimerId = setTimeout(() => {
				if (typeof Shark.activePage.updateTextFilters === "function") {
					Shark.activePage.updateTextFilters(searchKey);
				}
			}, 750);
		}
	}

	init () {
		const liveSearchFilter = Shark.getInstance("__smart__", {
			searchKey: "",
			visibleCount: 0,
		});


		liveSearchFilter.on("searchKeyChanged", function () {
			this.searchKey = this.searchKey.toLowerCase();
			liveSearchComponent.filter(this.searchKey);
		});

		Shark.set({liveSearchFilter});
	}

	reset () {
		const liveSearchFilter = Shark.get("liveSearchFilter");
		liveSearchFilter.set("searchKey", "");
	}

	setFocus () {
		const liveSearchField = document.querySelector("#liveSearchField");

		if (liveSearchField) {
			liveSearchField.focus();
		}
	}
}

const liveSearchComponent = new LiveSearchComponent();

Shark.registerComponent(liveSearchComponent);

export default liveSearchComponent;
